import React, { useEffect, useState } from 'react';

/**
 * HupalupaQ4_2026: HUPALUPA Store son çeyrek 2026 stratejisi ve bütçe önerisi.
 * Route: /budget/hupalupa-son-ceyrek-2026 (sidebar YOK, tam ekran slayt gösterisi)
 *
 * 14 slayt, 16:9, apple.com tasarım dili. Learning Resources ve Gürgençler
 * sunumlarıyla aynı hattan. Yeniden üretmek için:
 *   node src/pages/hupalupa-q4-2026/build.js
 *
 * 🔑 "PDF olarak indir" düğmesi belgenin İÇİNDE. iframe dışından Ctrl+P
 * slaytları tek sayfaya kırpar; düğmeyi dışarı taşıma.
 * 🔴 iframe'e sandbox EKLEME, PDF indirme kırılır.
 *
 * HTML modülü ~73KB, ana bundle'da işi yok: dinamik import ile yükleniyor.
 */
export default function HupalupaQ4_2026() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('../hupalupaQ4Html')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#1d1d1f">Sunum yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  // Yükleme zemini sunumun kendi zemini (--deck) ile aynı, açılışta flaş olmasın.
  if (!html) return <div style={{ ...fill, background: '#F0F0F2' }} />;

  return (
    <iframe
      title="HUPALUPA Store · Son Çeyrek 2026"
      srcDoc={html}
      style={fill}
    />
  );
}
